"use client";
import { useState } from "react";

import PageContainer from "@/app/admin/_common/PageContainer";

import { useAutomationDetailModel } from "./automationDetailPageModel";
import { useAutomationSchema } from "../_cmp/useAutomationSchema";
import AutomationDetailHeader, { DetailTab } from "./_cmp/AutomationDetailHeader";
import AutomationDetailSkeleton from "./_cmp/AutomationDetailSkeleton";
import AutomationStatTiles from "./_cmp/AutomationStatTiles";
import KillSwitchBar from "./_cmp/KillSwitchBar";
import RunsTable from "./_cmp/runs/RunsTable";
import SetupTab from "./_cmp/setup/SetupTab";
import TemplateTab from "./_cmp/template/TemplateTab";

export default function AutomationDetailPage() {
  const [tab, setTab] = useState<DetailTab>("setup");
  const {
    automation,
    runs,
    stats,
    isLoading,
    isSavingStatus,
    changeStatus,
    saveAutomation,
    saveTemplate,
  } = useAutomationDetailModel();
  const { schema, isLoading: isSchemaLoading } = useAutomationSchema();

  const loading = isLoading || isSchemaLoading || !automation || !schema;

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <AutomationDetailHeader automation={automation} tab={tab} onTabChange={setTab} />

        {/* The template tab hosts the email builder, which needs the full height and
            width of the pane -- the 920px scrolling column below would crush it. */}
        {!loading && tab === "template" ? (
          <div className="flex min-h-0 flex-1 flex-col">
            <div className="flex-shrink-0 px-5 py-3">
              <KillSwitchBar
                automation={automation}
                isSaving={isSavingStatus}
                onChange={changeStatus}
              />
            </div>

            <TemplateTab
              automation={automation}
              schema={schema}
              onSave={saveTemplate}
            />
          </div>
        ) : (
          <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-5 py-5">
            <div className="mx-auto flex w-full max-w-[920px] flex-col gap-4">
              {loading ? (
                <AutomationDetailSkeleton />
              ) : (
                <>
                  <AutomationStatTiles stats={stats} />

                  <KillSwitchBar
                    automation={automation}
                    isSaving={isSavingStatus}
                    onChange={changeStatus}
                  />

                  {tab === "setup" && (
                    <SetupTab
                      automation={automation}
                      schema={schema}
                      onSave={saveAutomation}
                    />
                  )}

                  {tab === "runs" && (
                    <div className="flex min-h-[420px] flex-col">
                      <RunsTable runs={runs} />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
}
